import React, { useEffect, useState } from 'react';
import { config } from '../../../../config';
import axiosApi from '../../../../core/interceptor/interceptor';

export default function ModifyAdminPriviliges(props) {

    const [permissions, setPermissions] = useState([]);
    const [myPermissions, setMyPermissions] = useState([]);

    useEffect(() => {
        props.permissions(myPermissions);
        //eslint-disable-next-line
    }, [myPermissions])

    useEffect(() => {
        const getUserPermissions = () => {
            axiosApi.get(`${config.apiUrl}/permissions?userId=${props.userId}`)
                .then((response) => {
                    if (response.data && response.data.data && response.data.data.length) {
                        const ids = response.data.data.map(x => x.permission_id);
                        setMyPermissions(ids);
                        props.permissions(ids);
                    }
                    getPermissions();
                });
        }

        !props.userId ? getPermissions() : getUserPermissions();
        //eslint-disable-next-line
    }, []);

    const getPermissions = () => {
        axiosApi.get(`${config.apiUrl}/permissions/all`)
            .then((response) => {
                setPermissions(response.data.data);
            });
    }



    const handleChange = (id, parentId) => {
        let arr = [...myPermissions];
        const idx = arr.indexOf(id);
        if (idx > -1) {
            arr.splice(idx, 1);
            if (!parentId) {
                const childIds = [...permissions].filter(x => x.parent_id === id).map(x => x.id);
                arr = arr.filter((el) => !childIds.includes(el));
            }
        } else {
            arr.push(id);
            if (parentId) {
                const indx = arr.indexOf(parentId);
                if (indx === -1) {
                    arr.push(parentId);
                }
            }

            if (!parentId) {
                const childIds = [...permissions].filter(x => x.parent_id === id).map(x => x.id);
                childIds.forEach(x => {
                    const index = arr.indexOf(x);
                    if (index === -1) {
                        arr.push(x);
                    }
                })
            }
        }

        setMyPermissions(arr);
    }

    useEffect(() => {
        const temp = [];
        if (permissions && permissions.length) {
            permissions.forEach((val) => {
                if(!val.parent_id) {
                    temp.push(val);  
                } else {
                    const index = temp.findIndex(x => x.id === val.parent_id);
                    temp.splice(index+1,0 ,val );

                }
            })
        }
        
        setPermissions(temp);
    }, [permissions.length])
    return <>
        <div className="modifyAdmin-privileges" style={{ minHeight: 410 }}>
            {
                permissions.map((x, i) =>
                    <div className={x.parent_id ? 'inner-blk child' : 'inner-blk'} key={i}>
                        <label className="checkbox">
                            {x.name}
                            <input type="checkbox" value={x.id} checked={myPermissions.indexOf(x.id) > -1 ? true : false} onChange={() => handleChange(x.id, x.parent_id)} />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                )
            }
        </div>
    </>
}

